export default __webpack_public_path__ + "static/media/send.a5b4c2c5.svg";